import { Input } from "antd";
import { IoSearchOutline } from "react-icons/io5";
import { useInfoUser } from "../../../store/UserStore";
import { useDirectoryContext } from "./DirectoryContext";
import { QuickOrganization } from "./QuickOrganization";

const QuickDirectory = () => {
  const { languageMap } = useInfoUser();
  const { orgList, setOrgList, debouncedFilterOrg } =
    useDirectoryContext();

  return (
    <div className="!text-[12px]">
      <Input
        className="w-[98%] mt-2"
        placeholder={languageMap?.["menu.search.placeholder"] ?? "Search"}
        onChange={(event) => {
          debouncedFilterOrg(event.target.value.trim());
        }}
        prefix={<IoSearchOutline size={15} />}
        allowClear
      />
      <div className="py-[10px]">
        <QuickOrganization
          onlyView={true}
          setOrgList={setOrgList}
          orgList={orgList}
        />
      </div>
    </div>
  );
};

export { QuickDirectory };
